import * as React from "react"
import ImageList from "@mui/material/ImageList"
import ImageListItem from "@mui/material/ImageListItem"

import { ImageListItemBar } from "@mui/material"

export default function QuiltedImageList({
    data = [],
    selected = [],
    handleChange,
    selectAll,
}) {
    return (
        <ImageList
            sx={{ width: 500, height: 450 }}
            variant="quilted"
            cols={3}
            rowHeight={121}
        >
            {data.map((item) => {
                const isCarousel = item.media_type === "CAROUSEL_ALBUM"
                const isVideo =
                    item.media_type === "VIDEO" ||
                    item.media_type === "REEL" ||
                    item.media_type === "LIVE_VIDEO"

                // Para carrossel, pega a primeira mídia como capa
                const thumbnail = isCarousel
                    ? item.children?.data[0]?.media_url
                    : item.media_url

                return (
                    <ImageListItem
                        key={item.img}
                        cols={1}
                        rows={isVideo ? 2 : 1}
                        sx={{
                            position: "relative",
                            cursor: "pointer",
                        }}
                        onClick={() => handleChange(item.id)}
                    >
                        <input
                            type="checkbox"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                cursor: "pointer",
                            }}
                            checked={selected.includes(item.id) || selectAll}
                            onClick={() => handleChange(item.id)}
                        />

                        {isVideo ? (
                            <video
                                src={thumbnail}
                                muted
                                autoPlay
                                loop
                                style={{ width: "100%", display: "block" }}
                            />
                        ) : (
                            <img
                                src={thumbnail}
                                alt={item.title}
                                loading="lazy"
                            />
                        )}

                        <ImageListItemBar title={item.caption} />
                    </ImageListItem>
                )
            })}
        </ImageList>
    )
}
